import {Component, Input, OnInit} from '@angular/core';
import { isCVSplitApplied } from 'src/app/helpers/isCvSplitApplied';

@Component({
    selector: 'app-product-tooltip',
    templateUrl: './product-tooltip.component.html',
    styleUrls: ['./product-tooltip.component.scss']
})
export class ProductTooltipComponent implements OnInit {

    isCVSplitApplied = isCVSplitApplied();

    @Input() public product: any;

    @Input() public direction: 'ltr' | 'rtl' = 'rtl';

    @Input() public showAlways: boolean = false;

    constructor(
      
    ) {
    }

    ngOnInit() {

    }
} 